var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "United States flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B22234",
    d: "M0 0h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24V16H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3B6E",
    d: "M0 0h10.3v8.62H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.15,
    cy: 1.1,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1,
    cy: 1.1,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.05,
    cy: 1.1,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 1.1,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.95,
    cy: 1.1,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.12,
    cy: 2.15,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.07,
    cy: 2.15,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.02,
    cy: 2.15,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.97,
    cy: 2.15,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.15,
    cy: 3.2,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1,
    cy: 3.2,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.05,
    cy: 3.2,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 3.2,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.95,
    cy: 3.2,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.12,
    cy: 4.25,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.07,
    cy: 4.25,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.02,
    cy: 4.25,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.97,
    cy: 4.25,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.15,
    cy: 5.3,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1,
    cy: 5.3,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.05,
    cy: 5.3,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 5.3,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.95,
    cy: 5.3,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.12,
    cy: 6.35,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.07,
    cy: 6.35,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.02,
    cy: 6.35,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.97,
    cy: 6.35,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.15,
    cy: 7.4,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1,
    cy: 7.4,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.05,
    cy: 7.4,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.4,
    r: 0.34
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.95,
    cy: 7.4,
    r: 0.34
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUs);
export default __webpack_public_path__ + "static/media/flag-us.c4b33766b1e682a6d25a65988fe27974.svg";
export { ForwardRef as ReactComponent };